(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('HistoryMetadataService', HistoryMetadataService);

  HistoryMetadataService.$inject = ['$resource'];

  function HistoryMetadataService ($resource) {
    return $resource(apiUrl + '/history-metadata/:id', { id: '@id' }, {
      loadHistoryMetadata: { url: apiUrl + '/get-history-metadata/:contact_id/:meta_key', isArray: false }
    });
  }
})();
